import React from 'react'
import * as Styled from './Indicator.styles'
import PropTypes from 'prop-types'

/**
 * rating for quality indicators
 * @param rating
 * @param variant
 * @returns {string|unknown[]}
 * @constructor
 */
const Indicator = ({ rating, variant = 'circle', isFilter = false }) => {
  const maxRating = variant === 'square' ? 4 : 5

  if (rating === -1) {
    return 'NP'
  }

  if (rating === 7) {
    return 'EF'
  }

  if (!isFilter && (rating === 0 || rating === 6)) {
    return <Styled.Cross />
  }

  return [...Array(maxRating).keys()].map((v) => (
    <Styled.QualityIndicatorIcon
      key={ `item-${ v }` }
      className={ `${ variant } ${ v + 1 <= rating && 'filled' }` }
    />
  ))
}

Indicator.propTypes = {
  rating: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  variant: PropTypes.oneOf(['circle', 'square']),
}

export default Indicator
